import { checkDate } from "common/helpers/Date";
import { DateStringNumber, Nullable } from "common/records";
import { Record } from "immutable";

export const roomEstimationFromJSON = (json: Partial<IRoomEstimationData>): RoomEstimationRecord => {
  const recordData: IRoomEstimationRecord = { ...(json as any) };

  if (json.created_at) {
    recordData.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    recordData.updated_at = checkDate(json.updated_at);
  }

  return new RoomEstimationRecord(recordData);
};

export interface IRoomEstimationData {
  id: number;
  room_id: number;
  estimate_group_id: number;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface IRoomEstimationRecord {
  id: number;
  room_id: number;
  estimate_group_id: number;

  created_at: Nullable<Date>;
  updated_at: Nullable<Date>;
}

const defaultSkuProps: IRoomEstimationRecord = {
  id: 0,
  room_id: 0,
  estimate_group_id: 0,

  created_at: null,
  updated_at: null,
};

export class RoomEstimationRecord extends Record(defaultSkuProps) implements IRoomEstimationRecord {}
